/* eslint-disable */
import { SIDEBAR_RIGHT_OPEN } from '../Sidebar.types';

/**
 * Open the sidebar
 * @returns {ActionCreator<FromPayload<null, {}, SIDEBAR_RIGHT_OPEN>>} The created `Action`
 */
const sidebarRightOpen = () => ({ fromPayload }) => {
  return fromPayload(null, {}, SIDEBAR_RIGHT_OPEN);
};

export default sidebarRightOpen;
